<template>
    <div class="index-main">
        <header-bar tab-index="5"/>

        <about-panel/>

        <side-bar/>
        <footer-bar/>
    </div>
</template>

<script>
import HeaderBar from "../../components/header";
import FooterBar from "../../components/footer";
import SideBar from "../../components/sider";
import AboutPanel from '../../components/index/about';
import '../../resource/css/common.css';

export default {
    name: "aboutIndex",
    components: {
        'header-bar': HeaderBar,
        'footer-bar': FooterBar,
        'side-bar': SideBar,
        'about-panel': AboutPanel,
    },
}
</script>

<style scoped>
    .index-main {
        padding-top: 100px;
    }
</style>
